/// <reference types="node" />
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { buildSentryOptions } from './app/sentry/sentry-options';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

// Initialize Sentry only if enabled in environment
if (environment.sentry?.enabled) {
	Sentry.init(buildSentryOptions());
} else {
	console.log(`Sentry disabled for environment: ${environment.production ? 'production' : 'development'}`);
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.log(err));
